function paramsToQueryString(input) {
    let params = input;
    if (!(params && Object.prototype.toString.call(params) === '[object Object]')) {
        throw new TypeError('GET параметры должны быть объектом.');
    }

    params = Object.keys(params).reduce((acc, key) => {
        if (!Array.isArray(params[key])) {
            throw new TypeError('Значение параметра должно быть массивом');
        }
        params[key].forEach((item) => acc.push([key, item]));
        return acc;
    }, []);

    return new URLSearchParams(params).toString();
}

function parse(query) {
    return [...new URLSearchParams(query).entries()].reduce((acc, [key, value]) => {
        if (!acc[key]) {
            acc[key] = [value];
            return acc;
        }

        acc[key].push(value);
        return acc;
    }, {});
}

const DUMMY_PROTOCOL = 'https:';
const DUMMY_SEPARATOR = '//';
const DUMMY_HOST = 'dummy.dummy';
const DUMMY_BASE = `${DUMMY_PROTOCOL}${DUMMY_SEPARATOR}${DUMMY_HOST}`;

function urlParser(urlString) {
    let href = urlString;
    if (!href) {
        href = '';
    }
    const url = new URL(href, DUMMY_BASE);

    const object = {
        params: parse(url.search),
        protocol: url.protocol,
        hostname: url.hostname,
        host: url.host,
        port: url.port,
        pathname: url.pathname,
        search: url.search,
        hash: url.hash,
    };

    defineProperties(object, true);

    return object;

    function defineProperties(object, enumerable) {
        Object.defineProperty(object, 'href', {
            get() {
                url.search = paramsToQueryString(object.params);
                url.hash = object.hash;
                return url.href.replace(DUMMY_BASE, '');
            },
            set(value) {
                url.href = value;
                object.params = parse(url.search);
            },
            enumerable,
        });

        Object.defineProperty(object, 'search', {
            get() {
                url.search = paramsToQueryString(object.params);
                return url.search;
            },
            set(value) {
                url.search = value;
                object.params = parse(url.search);
            },
            enumerable,
        });

        Object.defineProperty(object, 'host', {
            get() {
                return url.hostname + (url.port === '' ? '' : `:${url.port}`).replace(DUMMY_HOST, '');
            },
            set(value) {
                const [host, port] = value.split(':');
                url.hostname = host;
                if (port) {
                    object.port = port;
                } else {
                    url.port = '';
                }
            },
            enumerable,
        });

        Object.defineProperty(object, 'hostname', {
            get() {
                return url.hostname.replace(DUMMY_HOST, '');
            },
            set(value) {
                url.hostname = value;
            },
            enumerable,
        });

        Object.defineProperty(object, 'port', {
            get() {
                return url.port === '0' || url.port === '80' ? '' : url.port;
            },
            set(value) {
                if (isNaN(parseInt(value, 10))) {
                    throw new TypeError('Порт должен быть числом');
                }
                url.port = value;
            },
            enumerable,
        });

        Object.defineProperty(object, 'protocol', {
            get() {
                return url.protocol;
            },
            set(value) {
                url.protocol = value;
            },
        });

        Object.defineProperty(object, 'pathname', {
            get() {
                return url.pathname.indexOf('/') === 0 ? url.pathname : `/${aContainer.url}`;
            },
            set(value) {
                url.pathname = value;
            },
        });
    }
}

// urlParser params работает по контракту {key: [value1, value2]}, стрингифай же должен работать и с {key: value} кейсом
urlParser.stringify = (input) => {
    if (!input) {
        return '';
    }

    let params = input;
    if (!Array.isArray(params)) {
        params = Object.keys(params).reduce((acc, key) => {
            if (params[key] === null) {
                return acc;
            }
            if (Array.isArray(params[key])) {
                params[key].forEach((item) => acc.push([key, item]));
                return acc;
            }
            acc.push([key, params[key]]);
            return acc;
        }, []);
    }
    return new URLSearchParams(params).toString();
};

export default urlParser;
